import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { IdealProfileState, RootState } from './ideal-profile-types';

export const state: IdealProfileState = {
  idealProfile: undefined,
  error: false,
};

const namespaced = true;

export const idealProfile: Module<IdealProfileState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
